import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'

import { LoginComponent } from './login/login.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { BrowserModule } from '@angular/platform-browser'
import { CommonModule } from '@angular/common'
import { DxLoadIndicatorModule } from 'devextreme-angular'
import { NotFoundComponent } from './notFound/not-found.component'
import { ServerErrorComponent } from './serverError/server-error.component'
import { ForbiddenComponent } from './forbidden/forbidden.component'
import { SharedModule } from '../shared/shared.module'

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    BrowserModule,
    DxLoadIndicatorModule,
    SharedModule,
  ],
  declarations: [LoginComponent, NotFoundComponent, ServerErrorComponent, ForbiddenComponent],
  exports: [
    RouterModule,
    LoginComponent,
    NotFoundComponent,
    ServerErrorComponent,
    ForbiddenComponent,
  ],
})
export class PagesModule {}
